import React from 'react';
import { Footer } from 'festo-react-ui-kit';
import Header from '../../components/Header';

import { useAppSelector } from '../../app/hooks';
import useTranslation from '../../features/translation/hooks/useTranslation';

interface ContainerProps {
  children: React.ReactNode;
}


enum TranslationKeys {
  FOOTER_FESTO = 'footerFesto',
  FOOTER_COPYRIGHT = 'footerCopyright',
}

export default function Container({ children }: ContainerProps): JSX.Element {
  const t = useTranslation();
  const { applicationType } = useAppSelector((state) => state.base);

  const showHeaderAndFooter = !(applicationType === 'fox');
  return (
    <>
      {showHeaderAndFooter && <Header />}
      {children}
      {showHeaderAndFooter && (
        <Footer
          style={{
            marginTop: '48px',
            paddingTop: '35px',
          }}
          copyrightText={`${t(TranslationKeys.FOOTER_FESTO)} ${t(TranslationKeys.FOOTER_COPYRIGHT)}`}
          links={[]}
        />
      )}
    </>
  );
}
